import React from 'react';
import { useTranslation } from 'react-i18next';
import { OrderDetailProps } from 'pages/MyOrdersPage/AscOrders/AscOrderDetail';
import { Flex, Text } from 'UI';
import { textFormatter } from 'utils';
import { isValidDate } from 'utils/format/formattingService';

const AscOrderDetailInformation = ({ orderDetail }: OrderDetailProps) => {
  const { t } = useTranslation();
  const getDateAndTime = () => {
    const { orderDate } = orderDetail;
    if (!orderDate || !isValidDate(orderDate)) {
      return undefined;
    }
    return <>{textFormatter.formatTime(new Date(orderDate))}</>;
  };

  return (
    <Flex gap={30}>
      <Flex direction={'column'} size={0}>
        <Text type="lg" disableGutter noWrap>
          {t('order.order_detail.order_number', 'Order Number')}
        </Text>
        <Text type="lg" disableGutter noWrap>
          {t('asc_order.dms_number', 'DMS number')}
        </Text>
        <Text type="lg" disableGutter noWrap>
          {t('common.date_and_time', 'Date and time')}
        </Text>
      </Flex>
      <Flex direction={'column'}>
        <Flex>
          <Text type="lg" bold disableGutter noWrap>
            {orderDetail.salesOrderNumber}
          </Text>
        </Flex>
        <Flex>
          <Text type="lg" bold disableGutter noWrap>
            {orderDetail.salesOrderCustomerReference}
          </Text>
        </Flex>
        <Flex>
          <Text type="lg" bold disableGutter noWrap>
            {getDateAndTime()}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default AscOrderDetailInformation;
